import { createFileRoute, stripSearchParams } from "@tanstack/react-router";
import { zodValidator } from "@tanstack/zod-adapter";
import { Suspense } from "react";
import { PROJECT } from "@/app/capabilities/permissions";
import { mcpGatewaysQueryOptions } from "@/app/mcp-gateways/api/get-mcp-gateways";
import { MCPGatewaysListSkeleton } from "@/app/mcp-gateways/components/mcp-gateways-list-skeleton";
import { MCPGatewayList } from "@/app/mcp-gateways/list";
import {
  mcpGatewaysSearchDefaults,
  mcpGatewaysSearchSchema,
} from "@/app/mcp-gateways/search-params";
import { requireProjectPermission } from "@/lib/route-guards";

export const Route = createFileRoute(
  "/_authenticated/orgs/$organizationId/projects/$projectId/mcp-gateways"
)({
  validateSearch: zodValidator(mcpGatewaysSearchSchema),
  search: {
    middlewares: [stripSearchParams(mcpGatewaysSearchDefaults)],
  },
  component: () => (
    <Suspense fallback={<MCPGatewaysListSkeleton />}>
      <MCPGatewayList />
    </Suspense>
  ),
  async beforeLoad(ctx) {
    await requireProjectPermission(ctx, PROJECT.mcpGateways.read);
    ctx.context.queryClient.prefetchQuery(
      mcpGatewaysQueryOptions({ binding: "project", scope: ctx.params })
    );
  },
  loader: () => ({
    crumb: "MCP Gateways",
  }),
});
